import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import './index.css';
import './dark-theme.css';
// LAST on purpose: strips decoration on phones and wins over the sheets above.
import './mobile-performance.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// public/index.html is sending this tab from nahdi.tech to pro.mize.sa: don't start the app here.
if (!(window as any).__mizeMoving) {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
